import { getSessionStorage } from '/@/utils/storage'
import { decrypt } from '/@/utils/crypto'
export default (to, from, next) => {
  // 判断当前路由是否插件路由
  if (to.meta && to.meta.plugin) {
    const plugin = to.meta.plugin
    const zhPlugin = getSessionStorage('zh_plugin') || ''
    // 如果有插件，校验当前路由是否存在于插件中
    // 如果没有获取到缓存中的插件加密信息则跳404
    if (zhPlugin) {
      const zhPluginArr = decrypt(zhPlugin).split(',')
      if (!zhPluginArr.includes(plugin)) {
        next('/404')
        return
      }
    } else {
      next('/404')
    }
  }
  next()
}
